module.exports = __webpack_public_path__ + "static/sea-hag-mtg_cls-59fcc9e8bb454e3bd93c07f9a8cbf63f.jpg";